import React, { useState, useEffect } from 'react'
import http from '../../http'
import Filter from '../../context/Filter'
import Reload from '../../context/Reload'
import List from '../../context/List'
import Table from './_WhiteListTable'
import Columns from '../../context/Columns'
import { ColumnsSelector, ExportTable } from '../../components/Table'
import Filters from '../../components/Filters'
import Select from '../../components/Select'
import Placeholder from './_Placeholder'
import ReloadButton from '../../components/ReloadButton'

import Controls from './WhiteListControls'
import ToggleSelection from './_ToggleSelection'

import {
  FiRefreshCcw,
  FiFilter
} from 'react-icons/fi'

function Links( props ) {
  const [ client, setClient ] = useState( '' )
  const [ clients, setClients ] = useState( [] )
  const [ isFiltersOpened, setIsFiltersOpened ] = useState( false )
  const {
    before,
    excludedColumns,
  } = props

  useEffect( () => {
    if ( clients.length !== 0 ) return
    http
      .get( '/api/collection/dataSource/all' )
      .then( response => {
        setClients( response.data )
      } )
  } )

  function toggleFilters() {
    setIsFiltersOpened( ! isFiltersOpened )
  }

  function onClientChange( e, toggle ) {
    setClient( e.target.value )
    toggle()
  }

  if ( client === '' ) {
    return <Placeholder
      clients={ clients }
      client={ client }
      onClientChange={ onClientChange }
    />
  }

  return (
    <Filter>
      <Columns
        endpoint={ `/api/dataSource/${ client }/whitelist/columns` }
        exclude={ excludedColumns }
      >
        <Reload>
        <List>
          <main>
            <header>
              <Select
                className="full"
                id="clientSelector"
                name="client"
                multiple={ false }
                value={ client }
                onChange={ onClientChange }
                placeholder="selecciona un cliente"
                options={ [
                  ...( clients.map( c => c.name ) )
                ] }
              />

              { client !== '' ? ( <div className="actions">

                <ToggleSelection />

                <ExportTable
                  action={ {
                    title: 'exportar tabla',
                    icon: 'HiOutlineDocumentReport',
                    endpoint: `/api/dataSource/${ client }/whitelist/export`,
                    useFilter: 1,
                    prefix: 'whitelist-',
                  } }
                />

                <button title="filtrar" onClick={ toggleFilters } >
                  <FiFilter />
                </button>

                <ReloadButton />

                <ColumnsSelector
                  action={ {
                    title: 'seleccionar columnas',
                    icon: 'FiColumns'
                  } }
                />
              </div> ) : null }
            </header>

            <section className="padding">

              <Controls
                client={ client }
              />

              <Table
                before={ before }
                client={ client }
              />
            </section>

            { isFiltersOpened ? <Filters
              close={ toggleFilters }
              prefix={ `/api/dataSource/${ client }/whitelist` }
              client={ client }
            /> : null }
          </main>
        </List>
        </Reload>
      </Columns>
    </Filter>
  )
}

export default Links
